import $http from './http';

//6-1获取报警信息（要权限）--------王智超
export const getAlarmInfo = (data) => {
    return $http.post('/collect/alarmConfig/getAlarmInfo', data);
};

//6-2报警设置保存（要权限）--------王智超
export const saveAlarmInfo = (data) => {
    return $http.post('/collect/alarmConfig/save', data);
};

/** 用户接口 */
/* 进线分析 */

// 4-1获取一年内12个月的容量/需量
export const getMonthDemandAndCapacity = (data) => {
    return $http.post('/collect/needAnalysis/getMonthDemandAndCapacity', data);
};

// 4-2获取一个月内每天的需量
export const getDayDemand = (data) => {
    return $http.post('/collect/needAnalysis/getDayDemand', data);
};

// 4-3获取一天内每小时的需量
export const getHourDemand = (data) => {
    return $http.post('/collect/needAnalysis/getHourDemand', data);
};

// 4-4导出一年内12个月的最大需量(李鸿飞)
export const exportMonthDemand = (data) => {
    return $http.post('/collect/needAnalysis/exportMonthDemand', data, {
        responseType: 'blob',
    });
};

// 4-5导出一个月内每天最大需量(李鸿飞)
export const exportDayDemand = (data) => {
    return $http.post('/collect/needAnalysis/exportDayDemand', data, {
        responseType: 'blob',
    });
};

// 4-6导出一天内每小时最大需量(李鸿飞)
export const exportHourDemand = (data) => {
    // return $http.post('/collect/needAnalysis/exportHourDemand', data, {
    //     responseType: 'blob'
    // });
    return $http.post('/collect/needAnalysis/exportMinuteDemand', data, {
        responseType: 'blob',
    });
};

// 4-7查询容量需量电费趋势图
export const getCapacityAndDemandCost = (data) => {
    return $http.post('/collect/needAnalysis/getCapacityAndDemandCost', data);
};

// 4-8查询一年中每个月目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getMonthPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/getMonthPowerAndCost', data);
};

// 4-9查询一个月每天目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getDayPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/getDayPowerAndCost', data);
};

// 4-9查询一天每天每小时目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getHourPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/getHourPowerAndCost', data);
};

// 4-10 导出一年12个月用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportMonthPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/exportMonthPowerAndCost', data, {
        responseType: 'blob',
    });
};

// 4-11 导出一个月每天用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportDayPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/exportDayPowerAndCost', data, {
        responseType: 'blob',
    });
};

// 4-12 导出一天每小时用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportHourPowerAndCost = (data) => {
    return $http.post('/collect/needAnalysis/exportHourPowerAndCost', data, {
        responseType: 'blob',
    });
};

// 4-13查询功率因数(李鸿飞)
export const getFactors = (data) => {
    return $http.post('/collect/needAnalysis/getFactors', data);
};

// 4-14 导出容量需量电费趋势图(李鸿飞)
export const exportCapacityAndDemandCost = (data) => {
    return $http.post(
        '/collect/needAnalysis/exportCapacityAndDemandCost',
        data,
        {
            responseType: 'blob',
        }
    );
};

// 4-15导出功率因数(李鸿飞)
export const exportFactors = (data) => {
    return $http.post('/collect/needAnalysis/exportFactors', data, {
        responseType: 'blob',
    });
};

// 11-1报警列表接口--------王智超
export const getAlarmList = (data) => {
    return $http.post('/collect/alarm/getAlarmList', data);
};

// 获取采集点
export const getSelectPoint = (data) => {
    return $http.post('/collect/common/getSelectPoint', data);
};

//
export const getIndexInfo = (data) => {
    return $http.post('/collect/common/getIndexInfo', data);
};

// 9.1查询和搜索（要权限) --张东秋
export const getYoyList = (data) => {
    return $http.post('/collect/analysis_yoy/getYoyList', data);
};

export const getTransformerLoad = (data) => {
    return $http.post('/collect/common/getTransformerLoad', data);
};

export const getActivePowerSum = (data) => {
    return $http.post('/collect/microgrid/getActivePowerSum', data);
};
export const getAccountMaxdemand = (data) => {
    return $http.post('/collect/microgrid/getAccountMaxdemand', data);
};
export const getMonthCapacityAndDemand = (data) => {
    return $http.post('collect/needAnalysis/getMonthCapacityAndDemand', data);
};
export const getDayFactors = (data) => {
    return $http.post('/collect/needAnalysis/getDayFactors', data);
};
export const getHourFactors = (data) => {
    return $http.post('/collect/needAnalysis/getHourFactors', data);
};


